import ProjectRequiredDocumentsForm from '../../components/ProjectRequiredDocuments';
import GrantProjectAccessForm from '../../components/grantProjectAccess';

import CreateProject from './CreateProject';

export const steps = [
  {
    label: 'project.description.title',
    optionnal: false,
    render: props => <CreateProject {...props}/>
  },
  {
    label: 'project.requiredDocuments.title',
    optionnal: true,
    render: props => <ProjectRequiredDocumentsForm {...props}/>
  },
  {
    label: 'project.grantAccess.title',
    optionnal: true,
    render: props => <GrantProjectAccessForm {...props}/>
  }
];

export default {
  steps
};
